import PropTypes from 'prop-types';
import { Fragment } from 'react';
import constants from '../../../config/constants';
import { AvailabilityMobileStyles } from './AvailabilityMobile.style';
import AvailabilityMobileItem from './AvailabilityMobileItem';
import AvailabilityMobileItemDownloadable from './AvailabilityMobileItemDownloadable';

const { AVAILABILITY_STOCKINSTORE, PRODUCT_TYPE } = constants;

const AvailabilityMobile = ({ availabilityCommonProps }) => {
  const {
    availabilityList,
    labelsData,
    sizes,
    colorVariants,
    deliveryData,
    deliveryActions,
    selectedType,
    setSelectedType,
    textGenerated = {},
    deliveryErrors,
    productData,
    variantData,
    appCtxData,
  } = availabilityCommonProps;

  const { SOFT_GOOD, GIFTCARD } = PRODUCT_TYPE;
  const isSoftProduct = productData.productType === SOFT_GOOD;
  const isGiftCard = productData.productType === GIFTCARD;
  const isSoftOrGiftCard = isSoftProduct || isGiftCard;

  return (
    <div className="availability">
      <div className="availability-container fa--availability-info__mobile">
        {isSoftOrGiftCard && <AvailabilityMobileItemDownloadable />}
        {availabilityList.map((item, index) => {
          if (isSoftOrGiftCard && item.shippingOptionType !== AVAILABILITY_STOCKINSTORE) {
            return null;
          }
          return (
            <Fragment key={item.shippingOptionType}>
              <AvailabilityMobileItem
                key={item.shippingOptionType}
                labelsData={labelsData}
                availability={item}
                isLast={index === availabilityList.length - 1}
                hasModal={index !== 3}
                sizes={sizes}
                colorVariants={colorVariants}
                availabilityList={availabilityList}
                deliveryData={deliveryData}
                deliveryActions={deliveryActions}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                textGenerated={textGenerated}
                deliveryErrors={deliveryErrors}
                productData={productData}
                variantData={variantData}
                appCtxData={appCtxData}
              />
              {index === 1 && availabilityList.length > 3 && (
                <div className="availability-item title lastItem">
                  <span>{labelsData.AVAILABILITY_PDP}</span>
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
      <style jsx>{AvailabilityMobileStyles}</style>
    </div>
  );
};

AvailabilityMobile.propTypes = {
  availabilityCommonProps: PropTypes.shape({
    availabilityList: PropTypes.arrayOf(PropTypes.object).isRequired,
    labelsData: PropTypes.object.isRequired,
    sizes: PropTypes.array,
    colorVariants: PropTypes.array,
    deliveryData: PropTypes.object,
    deliveryActions: PropTypes.object,
    selectedType: PropTypes.string,
    setSelectedType: PropTypes.func,
    textGenerated: PropTypes.object,
    deliveryErrors: PropTypes.object,
    productData: PropTypes.object.isRequired,
    variantData: PropTypes.object.isRequired,
    appCtxData: PropTypes.object.isRequired,
  }).isRequired,
};

export default AvailabilityMobile;
